<template>
    <div class="modspec_font10">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Location(s)</div>
            <div class="col-sm-4 modspec_font12" v-if="!isJV3">Assessment scope</div>
            <div class="col-sm-4">
                <select class="form-select" v-model="result.scope" @change="selectScope" v-if="!isJV3">
                    <option value="">Select</option>
                    <option value="Site Specific">Site Specific</option>
                    <option value="Region" v-if="showRegion">Region</option>
                    <option value="Multiclimate" v-if="showMulti">Multi-climate</option>
                </select>
            </div>
        </div>

        <div class="row mt-3" v-if="result.scope == 'Site Specific' || isJV3">
            <div class="col-sm-4"></div>
            <div class="col-sm-8">
                <div id="dvLoadingSearchGeoAddress" class="spinner-grow spinner-grow-sm" role="status" style="display:none;">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <input type="text" class="form-control" placeholder="Start typing address and select" 
                    id="searchGeoAddress" v-model="result.address" autocomplete="off" ref="autocompleteGeoAddress"
                    @keyup.enter="find()" />                
            </div>
        </div>

        <div class="" v-if="result.scope == 'Region'">
            <div class="row mt-3">                
                <div class="col-sm-8 modspec_font12">
                    Click on the map to select the regions to be assessed
                </div>
            </div>       
            <div class="row mt-3">                
                <div class="col-sm-8">
                    <input class="form-check-input" type="checkbox" name="" id="chkManualInput" value="1"
                        v-model="manualInput"> 
                        <label class="form-check-label" for="chkManualInput modspec_font12"> Input manually the number of regions to calculate the price.</label>
                </div>
            </div>       
            
            <div class="row" v-if="manualInput">                                
                <div class="col-sm-12">
                    <div class="row mt-3">
                        <div class="col-sm-3 text-end modspec_font12">Climate Zones</div>
                        <div class="col-sm-3">
                            <input type="number" class="form-control" v-model="result.NumClimateZones"
                                @input="setText" :disabled="manualInput == false" />
                        </div>
                        <div class="col-sm-3 text-end modspec_font12">Weather files</div>
                        <div class="col-sm-3">
                            <input type="number" class="form-control" v-model="result.NumWeatherFiles"
                                @input="setText" :disabled="manualInput == false" />
                        </div>
                    </div>
    
                </div>
            </div>

        </div>
        
        
        <div v-if="this.result.scope == 'Multiclimate'">
            <div class="row mt-3">
                <div class="col-sm-12 modspec_font12">Select which climate zones you would like your assessment to cover</div>
            </div>
            
            <div class="row">
            <div class="col-sm-12 climateZoneBoxes" >
                <div :class="isMultizoneSelected(1) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(1)"><div>1</div></div>
                <div :class="isMultizoneSelected(2) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(2)"><div>2</div></div>
                <div :class="isMultizoneSelected(3) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(3)"><div>3</div></div>
                <div :class="isMultizoneSelected(4) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(4)"><div>4</div></div>
                <div :class="isMultizoneSelected(5) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(5)"><div>5</div></div>
                <div :class="isMultizoneSelected(6) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(6)"><div>6</div></div>
                <div :class="isMultizoneSelected(7) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(7)"><div>7</div></div>
                <div :class="isMultizoneSelected(8) ? 'selected' : ''" class="climateZoneBox modspec_font14 text-center" @click="setClimateZone(8)"><div>8</div></div>
            </div>
            </div>
        </div>

        <div v-else>
            <div  class="row">
                <div class="col-sm-12 modspec_font12">Selected for assessment:</div>
                <div v-if="!isDTS" class="col-sm-12 modspec_font12"><strong>Weather file(s):</strong> {{ result.WeatherFileName }}</div>
                <div class="col-sm-12 modspec_font12"><strong>Climate zone(s):</strong> {{ result.ClimateZoneName }}</div>
            </div>
       
            <div v-if="!isDTS" class="row mt-3">
                <div v-if="openMap==false"><a href='#' @click.prevent.self="openMap = true">Show map</a></div>
                <div v-if="openMap"><a @click.prevent.self="openMap = false" href='#'>Hide map</a></div>  
            </div>
        </div>
        
        
    
        <div id="loader" class="loader" style="display:none !important;"></div>
        <div class="row mt-3" v-show="openMap">
            <div class="col-sm-12" style="position:relative;">                               
                <div id="newloader" class="" style="">
                    <div id="map" style="min-height: 600px;"></div>
                </div>                
            </div>
        </div>
    
        

    </div>

</template>


<script>
import { Loader } from '@googlemaps/js-api-loader';
import { polygonHandler } from "../../helpers/polygons.js";

export default {
    name: "nq-address",
    props: ['method'],
    data: function () {
        return {
            result: {
                scope: '', 
                address: '',

                NumClimateZones:0,
                NumWeatherFiles:0,
                ClimateZones:[],
                WeatherFiles:[],
                ClimateZoneName:'',
                WeatherFileName:'',
            },
            loaderMap: {},
            manualInput: false,
            google: {},
            map: {},
            markerswf: [],
            openMap: false,
            activePolygons: [],
        }
    },
    mounted() {
        let self = this;
        this.loaderMap = new Loader({
            apiKey: "AIzaSyANtWMNHC1kS5qxqU-Y8XS1UR5foojE-hA",
            version: "weekly",
            libraries: ["places"]
        });


                
            

        this.loaderMap.load().then((google) => {
            this.google = google

            //-------------
            polygonHandler.loader.handleGetActivePoligons = function () {
                self.activePolygons = polygonHandler.map.methods.getActivePolygons();
            };
            setTimeout(() => {
                polygonHandler.init();
            }, 1000);
            //-------------

        }).catch(e => {
            console.log(e);
        });





        if(this.isJV3){
            this.setDefaultSiteSpecific();
        }

    },
    watch: {
        activePolygons(value, oldValue) {            
            console.log(oldValue);
            let climateZones = [];
            let czWF = [];

            value.forEach(function (poli) {  
                //console.log("POLI",poli);              
                if (!climateZones.includes(poli.cz)) {
                    climateZones.push(poli.cz);
                }

                //building a json CZ and WF
                let cz = czWF.find(c => c.cz == poli.cz);
                if(cz == undefined){czWF.push({cz:poli.cz,wf:[poli.properties.Column1]});}
                else{
                    cz.wf.push(poli.properties.Column1);
                }
                
            });

            this.result.ClimateZoneName = climateZones.toString();
            this.result.WeatherFileName = value.map(wf=> wf.properties.Column1).toString();

            this.result.NumClimateZones = climateZones.length;
            this.result.NumWeatherFiles = value.length;
            this.result.ClimateZones = climateZones;
            this.result.WeatherFiles = JSON.stringify(czWF.sort((a, b) => a.cz > b.cz));//this.result.WeatherFileName;

            console.log("CZ WF -> ",this.result.WeatherFiles);

            this.$emit('setAddress', this.result);
        },
        method(m,om){
            console.log("OM",om);
            if (m <= 2) {
                this.setDefaultSiteSpecific()
            }
        }
    },
    computed: {
        isJV3(){
            return this.$vtc.isJV(this.method);
        },
        showRegion() {
            return this.$vtc.isHB(this.method);
        },
        showMulti() {
            return this.$vtc.isDTS(this.method);
        },
        isDTS() {
            return this.$vtc.isDTS(this.method);
        },
    },
    methods: {
        setAddressValue(quote) {
            const climateZones = quote.climateZones || quote.ClimateZones || "";
            const weatherFiles = quote.weatherFiles || quote.WeatherFiles || "";
            const address = quote.address || quote.Address || "";
            const numWeatherFiles = quote.numWeatherFiles || quote.NumWeatherFiles || 0;
            const numClimateZones = quote.numClimateZones || quote.NumClimateZones || 0;

            this.result = {
                scope: address ? "Site Specific" : (numWeatherFiles > 0 ? "Region" : "Multiclimate"),
                address,
                NumClimateZones: numClimateZones,
                NumWeatherFiles: numWeatherFiles,
                ClimateZones: Array.isArray(climateZones)
                    ? climateZones
                    : climateZones.toString().split(",").filter(Boolean).map(Number),
                WeatherFiles: weatherFiles,
                ClimateZoneName: quote.climateZoneName || quote.ClimateZoneName || climateZones.toString(),
                WeatherFileName: quote.weatherFileName || quote.WeatherFileName || "",
            };
            this.openMap = this.result.scope != "Multiclimate";
            this.$emit('setAddress', this.result);
        },
        setDefaultSiteSpecific(){
            this.result.scope = 'Site Specific'
            this.selectScope();
        },
        isMultizoneSelected(z){
            return this.result.ClimateZones.includes(z);
        },
        setClimateZone(zone){
            if(this.result.ClimateZones.includes(zone)) {
                let ind = this.result.ClimateZones.indexOf(zone);
                this.result.ClimateZones.splice(ind,1);
            }
            else{
                this.result.ClimateZones.push(zone);
            }

            this.result.WeatherFiles = "";
            this.result.NumClimateZones = this.result.ClimateZones.length;
            this.result.NumWeatherFiles = 0;

            this.result.ClimateZoneName = "";
            if(this.result.ClimateZones.length > 0){
                this.result.ClimateZoneName = this.result.ClimateZones.sort().toString();
            }
            this.result.WeatherFileName = "";

            this.$emit('setAddress', this.result);
        },
        reset(keepScope) {            
            let scop = keepScope? this.result.scope: ''

            this.result = {
                scope:scop, 
                address: '',
                NumClimateZones:0,
                NumWeatherFiles:0,
                ClimateZones:[],
                WeatherFiles:[],
                ClimateZoneName:'',
                WeatherFileName:'',
            };

            polygonHandler.map.methods.clearActives();
            this.$emit('setAddress', this.result);
        },

        resetExtern(){

            this.result.scope = '';
            this.selectScope();
            
        },

        selectScope() {
            
            this.reset(true)

            if (this.result.scope == 'Region') {
                this.openMap = true;
                polygonHandler.data.isActive=true ;      
            } 
            else if (this.result.scope == 'Multiclimate') {
                this.openMap = false;
                polygonHandler.data.isActive=false ;      
            } 
            else {
                this.openMap = true;
                this.setUpAutoComplete();
                polygonHandler.data.isActive=false;
            }
                   
        },

        setUpAutoComplete() {
            let self = this

            setTimeout(() => {
                let options = {
                    componentRestrictions: { country: 'au' }
                }
                let input = this.$refs.autocompleteGeoAddress//.$el
                let autoComplete = new this.google.maps.places.Autocomplete(input, options)

                autoComplete.addListener('place_changed', function () {
                    self.addressSelected(input.value)
                })

            }, 2000);
        },


        addressSelected(address) {

            let geocoder = new this.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status == "OK") {
                    let currentPoint = results[0].geometry.location

                    //clear the previous selected
                    polygonHandler.map.methods.clearActives()                    

                    polygonHandler.map.methods.searchPolygonInParallel(currentPoint.lat(), currentPoint.lng());
                    polygonHandler.map.methods.showAdreess(currentPoint)

                    this.result.address = address

                    //this.result.NumClimateZones = 1;
                    
                    
                }
            })

        },

        setText() {
            this.result.address = ''
            this.result.WeatherFiles = []
            this.result.ClimateZones = []

            const timeoutId = window.setTimeout(() => { }, 0);
            for (let id = timeoutId; id >= 0; id -= 1) {
                window.clearTimeout(id);
            }

            setTimeout(() => {
                this.$emit('setAddress', this.result);
            }, 1000);
        },
    },
}

</script>

<style scoped>
.climateZoneBox{
    position:relative; float:left;border:1px solid #CFCFCF;width:12.5%;height:40px;
    cursor: pointer;
}
.climateZoneBox div{
    margin-top:9px;
    background-color: transparent;
}

.climateZoneBoxes > div:first-child {
    background-color: #F88B521A;
}
.climateZoneBoxes > div:first-child.selected {
    background-color: #F88B52 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes > div:first-child:hover {
    background-color: #F88B52;
}

.climateZoneBoxes div:nth-child(2) {
    background-color: #FBDD031A;
}
.climateZoneBoxes div:nth-child(2).selected {
    background-color: #FBDD03 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(2):hover {
    background-color: #FBDD03; 
}

.climateZoneBoxes div:nth-child(3) {
    background-color: #FDC56E1A;
}
.climateZoneBoxes div:nth-child(3).selected {
    background-color: #FDC56E !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(3):hover {
    background-color: #FDC56E 
}

.climateZoneBoxes div:nth-child(4) {
    background-color: #FEFAD71A; 
}
.climateZoneBoxes div:nth-child(4).selected {
    background-color: #FEFAD7 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(4):hover {
    background-color: #FEFAD7; 
}

.climateZoneBoxes div:nth-child(5) {
    background-color: #D2E2891A; 
}
.climateZoneBoxes div:nth-child(5).selected {
    background-color: #D2E289 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(5):hover {
    background-color: #D2E289; 
}

.climateZoneBoxes div:nth-child(6) {
    background-color: #7DCDE81A; 
}
.climateZoneBoxes div:nth-child(6).selected {
    background-color: #7DCDE8 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(6):hover {
    background-color: #7DCDE8; 
}

.climateZoneBoxes div:nth-child(7) {
    background-color: #1775BB1A; 
}
.climateZoneBoxes div:nth-child(7).selected {
    background-color: #1775BB !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(7):hover {
    background-color: #1775BB; 
}

.climateZoneBoxes div:nth-child(8) {
    background-color: #FFFFFF; 
}
.climateZoneBoxes div:nth-child(8).selected {
    background-color: #B5B5B5 !important; 
    font-weight: bold !important;
}
.climateZoneBoxes div:nth-child(8):hover {
    background-color: #B5B5B5; 
}

.mapOpen {
    min-height: 600px
}

.hide {
    display: none !important;
}

.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(201, 203, 215, 0.662);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loader::after {
    content: '';
    display: block;
    width: 50px;
    height: 50px;
    border: 5px solid #3498db;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
}
.newloader{
    position:relative; 
    min-height: 600px;
    width:auto;
    background-color: rgba(201, 203, 215, 0.662);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.newloader::after{
    content: '';
    display: block;
    width: 50px;
    height: 50px;
    border: 5px solid #3498db;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
}

.form-select{
    font-size: 12px !important;
}
.form-control{
  font-size: 12px !important;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
